import { computed, reactive, ref, toValue, type MaybeRefOrGetter, type WritableComputedRef } from 'vue'
import { useTenantStore } from '../stores/tenant'

// Deliberately RAM only: refresh/new login must start with defaults.
const entries = new Map<string, object>()
const generation = ref(0)
export function resetViewFilters() { entries.clear(); generation.value++ }

export function useViewFilters<T extends object>(scope: MaybeRefOrGetter<string>, defaults: () => T) {
  const tenant = useTenantStore()
  const active = computed(() => {
    generation.value
    const key = JSON.stringify([tenant.tenantId, toValue(scope)])
    if (!entries.has(key)) entries.set(key, reactive(defaults()))
    return entries.get(key) as T
  })
  return Object.fromEntries(Object.keys(defaults()).map(property => {
    const key = property as keyof T
    return [key, computed({ get: () => active.value[key], set: value => { active.value[key] = value } })]
  })) as { [K in keyof T]: WritableComputedRef<T[K]> }
}
